// Ruler system constants
export const RULER_SIZE = 30;
export const RULER_BG_COLOR = '#f0f0f0';
export const RULER_MARK_COLOR = '#666666';
export const RULER_TEXT_COLOR = '#333333';
export const GUIDELINE_COLOR = '#00a8ff';
export const GUIDELINE_WIDTH = 1;
export const SNAP_HIGHLIGHT_WIDTH = 2;

// These will be set dynamically to avoid circular dependency
export let GUIDELINE_SNAP_COLOR = '#ff6b00';
export let SNAP_THRESHOLD = 10;

// Update snap color dynamically
export const updateSnapColor = (color) => {
  GUIDELINE_SNAP_COLOR = color;
};

// Update snap threshold dynamically
export const updateSnapThreshold = (threshold) => {
  SNAP_THRESHOLD = threshold;
};
